/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NazioneCreateDTO
 */
export interface NazioneCreateDTO {
    /**
     * 
     * @type {string}
     * @memberof NazioneCreateDTO
     */
    descrizione?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof NazioneCreateDTO
     */
    paeseCee?: boolean;
    /**
     * 
     * @type {string}
     * @memberof NazioneCreateDTO
     */
    codiceCee?: string | null;
}

/**
 * Check if a given object implements the NazioneCreateDTO interface.
 */
export function instanceOfNazioneCreateDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function NazioneCreateDTOFromJSON(json: any): NazioneCreateDTO {
    return NazioneCreateDTOFromJSONTyped(json, false);
}

export function NazioneCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): NazioneCreateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'descrizione': !exists(json, 'descrizione') ? undefined : json['descrizione'],
        'paeseCee': !exists(json, 'paeseCee') ? undefined : json['paeseCee'],
        'codiceCee': !exists(json, 'codiceCee') ? undefined : json['codiceCee'],
    };
}

export function NazioneCreateDTOToJSON(value?: NazioneCreateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'descrizione': value.descrizione,
        'paeseCee': value.paeseCee,
        'codiceCee': value.codiceCee,
    };
}

